const parseBaseUrl = (baseUrl, defaultProtocol = 'https://') => new URL(/^https?:\/\//i.test(baseUrl) ? baseUrl : defaultProtocol + baseUrl);
export default parseBaseUrl;
